<template>
	<canvas id="wallpaper">
	</canvas>
</template>
<script>

  const startWallpaper = () => {
      //Base for WebGL pens
      //Replace fragmentSource content with desired GLSL code
      //Can create further uniform handles

      var canvas = document.getElementById("wallpaper");

      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      // Initialize the GL context
      var gl = canvas.getContext('webgl');
      if(!gl){
        console.error("Unable to initialize WebGL.");
      }

      //Time
      var time = 0.0;

      //************** Shader sources **************

      var vertexSource = `
      attribute vec2 position;
      void main() {
        gl_Position = vec4(position, 0.0, 1.0);
      }
      `;

      //Replace with GLSL fragment shader code
      var fragmentSource = `
      precision highp float;

      uniform float width;
      uniform float height;
      vec2 resolution = vec2(width, height);
      vec3 bl = vec3(0.867, 0.627, 0.867);
      vec3 br = vec3(0.314,0.808,0.788);
      vec3 tl = vec3(1.000, 0.627, 0.478);
      vec3 tr = vec3(0.829,1.000,0.981);
      
      uniform float time;

      void main(){

         vec2 pctPos  =  gl_FragCoord.xy / resolution.xy;
         float pctX =  0.5 + 0.5 * pctPos.x * cos(time);
         float pctY =  0.5 + 0.5 * pctPos.y * sin(time);
//         vec3 c = vec3(0.0);



        vec3 b = mix(bl, br, pctX);
        vec3 t = mix(tl, tr, pctX);
        vec3 c = mix(b, t, pctY);

// //       gl_FragColor = vec4(c,1.0);
//  //        gl_FragColor = vec4(c, cos(time) * sin(time) ,1.0);

        gl_FragColor = vec4(c, 1);
      }
      `;

      //************** Utility functions **************


      //Compile shader and combine with source
      function compileShader(shaderSource, shaderType){
        var shader = gl.createShader(shaderType);
        gl.shaderSource(shader, shaderSource);
        gl.compileShader(shader);
        if(!gl.getShaderParameter(shader, gl.COMPILE_STATUS)){
          throw "Shader compile failed with: " + gl.getShaderInfoLog(shader);
        }
        return shader;
      }

      //From https://codepen.io/jlfwong/pen/GqmroZ
      //Utility to complain loudly if we fail to find the attribute/uniform
      function getAttribLocation(program, name) {
        var attributeLocation = gl.getAttribLocation(program, name);
        if (attributeLocation === -1) {
          throw 'Cannot find attribute ' + name + '.';
        }
        return attributeLocation;
      }

      function getUniformLocation(program, name) {
        var attributeLocation = gl.getUniformLocation(program, name);
        if (attributeLocation === -1) {
          throw 'Cannot find uniform ' + name + '.';
        }
        return attributeLocation;
      }

      //************** Create shaders **************

      //Create vertex and fragment shaders
      var vertexShader = compileShader(vertexSource, gl.VERTEX_SHADER);
      var fragmentShader = compileShader(fragmentSource, gl.FRAGMENT_SHADER);

      //Create shader programs
      var program = gl.createProgram();
      gl.attachShader(program, vertexShader);
      gl.attachShader(program, fragmentShader);
      gl.linkProgram(program);

      gl.useProgram(program);

      //Set up rectangle covering entire canvas 
      var vertexData = new Float32Array([
        -1.0,  1.0, 	// top left
        -1.0, -1.0, 	// bottom left
         1.0,  1.0, 	// top right
         1.0, -1.0, 	// bottom right
      ]);

      //Create vertex buffer
      var vertexDataBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, vertexDataBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, vertexData, gl.STATIC_DRAW);

      // Layout of our data in the vertex buffer
      var positionHandle = getAttribLocation(program, 'position');

      gl.enableVertexAttribArray(positionHandle);
      gl.vertexAttribPointer(positionHandle,
        2, 				// position is a vec2 (2 values per component)
        gl.FLOAT, // each component is a float
        false, 		// don't normalize values
        2 * 4, 		// two 4 byte float components per vertex (32 bit float is 4 bytes)
        0 				// how many bytes inside the buffer to start from
        );

      //Set uniform handle
      var timeHandle = getUniformLocation(program, 'time');
      var widthHandle = getUniformLocation(program, 'width');
      var heightHandle = getUniformLocation(program, 'height');

      gl.uniform1f(widthHandle, window.innerWidth);
      gl.uniform1f(heightHandle, window.innerHeight);

      var lastFrame = Date.now();
      var thisFrame;



      function onWindowResize(){
        canvas.width  = window.innerWidth;
        canvas.height = window.innerHeight;
        gl.viewport(0, 0, canvas.width, canvas.height);
        gl.uniform1f(widthHandle, window.innerWidth);
        gl.uniform1f(heightHandle, window.innerHeight);
      }

      window.addEventListener( 'resize', onWindowResize, false );


      

      function draw(){
        
        //Update time
        thisFrame = Date.now();
        time += (thisFrame - lastFrame)/3000;	
        lastFrame = thisFrame;


        //Send uniforms to program
        gl.uniform1f(timeHandle, time);

        //Draw a triangle strip connecting vertices 0-4
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);

        requestAnimationFrame(draw);
      }

      draw();
  };

	export default {
		mounted(){
			startWallpaper();
		}
	}
</script>
<style lang="scss">
#wallpaper {
	background:#CCC;
	position: fixed;
	margin:0;
	top:0px;
	left:0px;
	width:100%;
	height:100%;
	z-index: -1;
} 
</style>
